'use client';

import { usePathname } from 'next/navigation';
import { Toaster } from 'react-hot-toast';
import Footer from '@/app/components/Footer';

export default function ContentArea({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();

    if (pathname?.startsWith('/raffle-overlay')) {
        return (
            <>
                {children}
                <Toaster position="top-right" />
            </>
        );
    }

    return (
        <div className="lg:pl-16">
            {children}
            <Toaster position="top-right" />
            <Footer />
        </div>
    );
}
